import { ChallengeModel } from "@/Domains";


/**
 * Class: ChallengeHelper
 *
 * Description:
 * Utility class providing helper functions to check the state of a ChallengeModel.
 * Responsibilities include:
 * - Determining if a challenge is blocked
 * - Determining if a challenge has been validated
 *
 * Author: Samano CASTRE
 * Date: July 17, 2025
 */
export class ChallengeHelper {

     /**
     * =====================================================
     * Block Status Check
     * =====================================================
     *
     * isBlocked - Returns true if the challenge is currently blocked.
     * A challenge is considered blocked if:
     * - `blockedAt` exists
     * - `unblockedAt` is either not set or occurs before `blockedAt`
     *
     * @param data - ChallengeModel instance
     * @returns boolean
     */
    static isBlocked = (data: ChallengeModel) => {
        if (!data.blockedAt) {
            return false;
        }
       
        if (!data.unblockedAt) {
            return true;
        }
        return data.blockedAt > data.unblockedAt;
    }


    /**
     * =====================================================
     * Validation Status Check
     * =====================================================
     *
     * isValidated - Returns true if the challenge has been validated.
     * Validation is determined by the presence of `validatedAt`.
     *
     * @param data - ChallengeModel instance
     * @returns boolean
     */
    static isValidated = (data: ChallengeModel) => {
        return !!data.validatedAt;
    }
}